import React from "react";
import styles from "./Calculator.module.css";

type CalculatorFooterProps = {
  sources: React.ReactNode[];
  cta?: React.ReactNode;
};

export const CalculatorFooter: React.FC<CalculatorFooterProps> = ({ sources, cta }) => (
  <div className="relative z-1 border-t border-white/9 px-7 pt-3.5 pb-5">
    <div className={styles.footerTitle}>Sources</div>
    <ul className={styles.footerList}>
      {sources.map((item, i) => (
        <li key={i} className={styles.footerItem}>
          <span className={styles.footerBullet}>·</span>
          {item}
        </li>
      ))}
    </ul>
    {cta && <div className={styles.footerCta}>{cta}</div>}
  </div>
);
